import React, { useState } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Row,
  Col,
  message,
} from "antd";
import "./setPassword.css";
import crediXLogo from "../../assets/image/component 1.svg.svg";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setLoader } from "../../state/slices/loader";
import config from "../../config/api.config"
const { baseURL } = config;
const SetPassword = () => {
  const [form] = Form.useForm();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const onFinish = async () => {
    dispatch(setLoader(true));
    const token = searchParams.get("token");
    // 
    
    await axios
      .post(
        `${baseURL}user/set-password?token=${token}`,
        {
          password: password,
          confirmPassword: confirmPassword,
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        dispatch(setLoader(false));
        if (response.data?.resCode === -1) {
          message.success(
            "Password set successfully. Please login into your account."
          );
        } else {
          
        }
      })
      .catch((error) => {
        dispatch(setLoader(false));
        switch (error.response?.data?.resCode) {
          case 1:
            message.error("Validation error. Please check your input.");
            break;
          case 6:
            message.error(
              "An error occurred while setting the password. Please try again."
            );
            break;
          case 10:
            message.error("The passwords do not match. Please try again.");
            break;
          default:
            message.error("Failed to set password. Please try again later.");
        }
        console.error("Password set error:", error);
      });
  };

  const onFinishFailed = () => {};

  return (
    <div className="login_wrapper">
      <Card className="login_card">
        <Form
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
        >
          <div className="d-flex justify-content-center">
            <img src={crediXLogo} alt="CreditX Logo" />
          </div>
          <div className="textarea">
            <div className="welcome" style={{ fontWeight: 'bold',textAlign: 'center' }}>Change Password!</div>
          </div>

          <Row gutter={[16, { xs: 16, sm: 10, md: 16, lg: 16 }]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                name="password"
                label="New Password"
                rules={[
                  {
                    required: true,
                    message: 'Please input your new password!',
                  },
                ]}
              >
                <Input.Password
                  placeholder="Enter Your New Password"
                  onChange={(e) => setPassword(e.target.value)}
                  className="phonenumber border" style={{ height: '35px' }}
                />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The two passwords that you entered do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder="Confirm Your New Password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="phonenumber border" style={{ height: '35px' }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="savebuttons">
              <Form.Item>
                <Button htmlType="submit" className="loginbtn">
                  Change Password
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default SetPassword;
